import { render, staticRenderFns } from "./tier_badge_popover.vue?vue&type=template&id=c54aafd4&"
import script from "./tier_badge_popover.vue?vue&type=script&lang=js&"
export * from "./tier_badge_popover.vue?vue&type=script&lang=js&"
import style0 from "./tier_badge_popover.vue?vue&type=style&index=0&id=c54aafd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports